import React from 'react'
import ReactDOM from 'react-dom'
import Menus from './Menus/index'
import Global from './Menus/types/Global'
import Item from './Menus/types/Item'
import Event from './events/types/Event'

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom"

const cache = Math.floor((new Date()).getTime() / (1000 * 60 * 15)); // Refetch api every 15 mins

Promise.all([
  fetch('/globals.json?' + cache).then(res => res.json()),
  fetch('/menus.json?' + cache).then(res => res.json()),
])
.then(res => {
  const menus = res[1].data.filter(i => i.type !== 'events')
  const events = res[1].data.filter(i => i.type === 'events')

  ReactDOM.render((
    <Router> {/* needed for useHistory */}
      <Menus
        globals={res[0].data as Array<Global>}
        menus={menus as Array<Item>}
        events={events as Array<Event>} 
      />
    </Router>
  ), document.getElementById('menus'))
})